import Chit from '@/components/chit/Chit';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { useModal } from '@/components/modal/useModal';
import SiFilter from '@/icons/SiFilter';
import { useCatalogueExplorerFilterService } from '@/services/catalogue/useCatalogueExplorerFilterService';
import { FunctionComponent, useEffect } from 'react';
import CatalogueExplorerFilterModal, { CatalogueExplorerFilterCallback } from './CatalogueExplorerFilterModal';

interface CatalogueExplorerFilterProps {
  categoryId?: string;
  onFilterCallback: (props: CatalogueExplorerFilterCallback) => void;
}

const CatalogueExplorerFilter: FunctionComponent<CatalogueExplorerFilterProps> = ({ categoryId, onFilterCallback }) => {
  const modalProps = useModal<{
    categoryId?: string;
    onFilterCallback: (props: CatalogueExplorerFilterCallback) => void;
  }>();

  const [specFilters, clearSpec, clearAll, manufacturerFilters, clearManufacturer] = useCatalogueExplorerFilterService(
    state => [state.specFilters, state.clearSpec, state.clearAll, state.manufacturerFilters, state.clearManufacturer]
  );

  useEffect(() => {
    onFilterCallback({ specs: specFilters, manufacturers: manufacturerFilters.map(item => item.id) });
  }, [specFilters, manufacturerFilters]);

  const onClearAll = () => {
    clearAll();
  };

  const filterChits = specFilters.flatMap(f => f.queries);

  return (
    <>
      <CatalogueExplorerFilterModal {...modalProps} />
      <div className="space-y-2">
        <div className="flex items-center justify-between space-x-2">
          <Button
            onClick={() => modalProps.open({ categoryId, onFilterCallback })}
            variant={ButtonVariant.Primary}
            className="w-64"
          >
            <SiFilter className="text-xl" />
            <span>Filter</span>
          </Button>
        </div>
        {(specFilters.length > 0 || manufacturerFilters.length > 0) && (
          <div className="flex space-x-2 items-center">
            <p className="font-semibold">Filtering By:</p>
            {filterChits.map((filter, index) => (
              <Chit name={filter} onDeleteCallback={clearSpec} key={`spec-${filter}-${index}`} />
            ))}
            {manufacturerFilters.map(filter => (
              <Chit
                name={filter.name}
                onDeleteCallback={() => clearManufacturer(filter.id)}
                key={`manufacturer-${filter.id}`}
              />
            ))}
            {filterChits.length + manufacturerFilters.length > 1 && (
              <Button onClick={onClearAll} variant={ButtonVariant.Ghost} className="text-semibold underline">
                Clear all
              </Button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default CatalogueExplorerFilter;
